import React, { useState, useEffect } from 'react';
import Badge from '../components/Badge';
import { NavLink, Navigate, useNavigate, useParams, useLocation } from 'react-router-dom';
import { format, parseISO, set } from 'date-fns';
import CurrencyFormat from '../components/CurrencyFormat';
import { DocumentDuplicateIcon, EyeSlashIcon, EyeIcon, BanknotesIcon, ArrowDownTrayIcon, PencilSquareIcon, ArrowsPointingOutIcon } from '@heroicons/react/24/outline';
import SubMenuJob from '../components/SubMenuJob';
import NotesOverlayJob from '../components/NotesOverlayJob';
// import StatsJob from '../components/StatsJob';
import TabsJob from '../components/TabsJob';
import DateFormat from '../components/DateFormat';
import SearchBarCP from '../components/SearchBarCP';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../custom.css';
import LegendCP from '../components/LegendCP';
import SubMenu from '../components/SubMenu';
// import LegendCP from '../components/LegendCP';
import ModalWindow from '../components/ModalWindow'
import ModalWipNotesSection from '../components/ModalWipNotesSection';
import WipComments from '../components/ModalWipNotesSection';
import { useUserData } from '../context/UserData';
import Modal from '../components/Modal';
import ToolTipCp from '../components/ToolTipCp';
import { ExclamationCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import SignedProposalCP from '../components/SignedProposalCP';
import LoadingSpinner from '../components/LoadingSpinner';
import HeadingCp from '../components/HeadingCp';
import classNames from 'classnames';
import SearchBarWithDropdown from '../components/SearchBarWithDropdown';
import Truncate from '../components/Truncate';
import ResponsiveNotes from '../components/ResponsiveNotes';

const WipListPage = () => {
  const [activeProjects, setActiveProjects] = useState(0);
  const [wipRemaining, setWipRemaining] = useState(0);
  const [wipComplete, setWipComplete] = useState(0);
  
  const [isModalFileOpen, setIsModalFileOpen] = useState(false);//file
  const [file, setFile] = useState(null);
  const [selectJobId, setSelectJobId] = useState(null);
  const [count, setCount] = useState(0);
  const {key} = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [jobNumber, setJobNumber] = useState(null);
  const [newObjct, setNewObjct] = useState({
                                            id: '',
                                            amount: '',
                                            notes: ''
                                          });
  const userData = useUserData();
  const [jobs, setJobs] = useState([]);
  const [creditHold, setCreditHold] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [bodyDataNotes, setBodyDataNotes] = useState({
                                                       status: 'submit_notes',
                                                       data: {notes: ''}
                                                      });
  const [loading, setLoading] = useState(true);
  const [showVoid, setShowVoid] = useState(false);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const navigate = useNavigate();
  const preWageClass = "hidden px-3 py-4 text-sm text-gray-500 sm:table-cell bg-green-300";
  // const [openNotes, setOpenNotes] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;
  const api = `${apiUrl}/wip_crud.php`
  const [openNotesJobId, setOpenNotesJobId] = useState(null); // Stores the ID of the job for which notes are shown
  
  // <-- NEW: Pagination states
  const [pageSize, setPageSize] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);

   // compute pagination
  const totalPages = Math.ceil(filteredJobs.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const currentProjects = filteredJobs.slice(startIndex, endIndex);

  const [expand, setExpand] = useState(false);
  // show jobs whose last note is within X days / has notes / no notes
  const [sortByLastNoteDesc, setSortByLastNoteDesc] = useState(false);
  const [lastNoteFilter, setLastNoteFilter] = useState('any'); // 'any' | '7d' | '30d' | 'has' | 'none'
  // NEW: sort by ID
  const [idSortDirection, setIdSortDirection] = useState(null); // 'asc' | 'desc' | null

  //to confirm void
  const [voidJobID, setVoidJobID] = useState(null);
  const [voidJobCurrentStatus, setVoidJobCurrentStatus] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // top of component
  const [notesIdOpen, setNotesIdOpen] = useState(null);

  const handleNotesView = (id) => setNotesIdOpen(id);
  const closeNotes = () => setNotesIdOpen(null);

    // Edit Job Site modal state
  const [baseRows, setBaseRows] = useState([]); // source list to filter/sort by notes
  const [isJobSiteModalOpen, setIsJobSiteModalOpen] = useState(false);
  const [jobSiteForm, setJobSiteForm] = useState({ id: null, job_site: '' });
  
  const [isVendorModalOpen, setIsVendorModalOpen] = useState(false);
  const [selectedVendorJob, setSelectedVendorJob] = useState(null);
  const [vendorForm, setVendorForm] = useState({
    vendor_name: '',
    notes: '',
  });

  const openVendorModal = (job) => {
    setSelectedVendorJob(job);
    setVendorForm({
      vendor_name: '',
      notes: '',
    });
    setIsVendorModalOpen(true);
  };

  const closeVendorModal = () => {
    setIsVendorModalOpen(false);
    setSelectedVendorJob(null);
    setVendorForm({
      vendor_name: '',
      notes: '',
    });
  };

  const handleVendorInputChange = (e) => {
    const { name, value } = e.target;

    setVendorForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddVendor = async () => {
    if (!selectedVendorJob?.job_number) {
      toast.error('Missing job number.', { position: 'top-center' });
      return;
    }

    if (!vendorForm.vendor_name.trim()) {
      toast.error('Vendor name is required.', { position: 'top-center' });
      return;
    }

    const bodyData = {
      status: 'add_wip_vendor',
      data: {
        job_number: selectedVendorJob.job_number,
        vendor_name: vendorForm.vendor_name.trim(),
        notes: vendorForm.notes.trim(),
      },
    };

    try {
      const response = await axios.post(`${apiUrl}/wip_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });

      if (response.data?.success) {
        const newVendor = response.data.vendor;

        setFilteredJobs((prev) =>
          prev.map((job) => {
            if (job.job_number === selectedVendorJob.job_number) {
              return {
                ...job,
                vendors: Array.isArray(job.vendors)
                  ? [...job.vendors, newVendor]
                  : [newVendor],
                acc_status: 'pending',
              };
            }

            return job;
          })
        );

        setJobs((prev) =>
          prev.map((job) => {
            if (job.job_number === selectedVendorJob.job_number) {
              return {
                ...job,
                vendors: Array.isArray(job.vendors)
                  ? [...job.vendors, newVendor]
                  : [newVendor],
                acc_status: 'pending',
              };
            }

            return job;
          })
        );

        toast.success('Vendor added!', { position: 'top-center' });

        setVendorForm({
          vendor_name: '',
          notes: '',
        });
      } else {
        toast.error(response.data?.error || 'Failed to add vendor.', {
          position: 'top-center',
        });
      }
    } catch (error) {
      toast.error('Server error adding vendor.', { position: 'top-center' });

      if (error.response?.status === 401) {
        navigate('/login');
      }
    }
  };  

  const buildViewState = () => ({
    searchTerm,
    showVoid,
    filteredJobs,
    baseRows,
    count,
    pageSize,
    currentPage,
    lastNoteFilter,
    sortByLastNoteDesc,
    idSortDirection,
    expand,
  });

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      toast.error("No file selected.", { position: 'top-center' });
      setFile(null);
      return;
    }

    const validFileTypes = ['application/pdf'];
    const maxSize = 5 * 1024 * 1024; // 2MB in bytes

    if (!validFileTypes.includes(selectedFile.type)) {
      toast.error("Invalid file type. Only PDF, PNG, and JPEG are allowed.", { position: 'top-center' });
      setFile(null);
      return;
    }

    if (selectedFile.size > maxSize) {
      toast.error("File size exceeds 5MB.", { position: 'top-center' });
      setFile(null);
      return;
    }
    setFile(selectedFile);
  };

  const handleUploadFile = (e) => {
    e.preventDefault();
    handleFormSubmit(file, selectJobId); // Changed here
    setFile(null);
    setIsModalFileOpen(false);
  }; 

  const handleFormSubmit = async (file, selectJobId) => {
    if (!file) {
      toast.error("Please upload a valid file.", { position: 'top-center' });
      return;
    }
   const formData = new FormData();
    formData.append('status', 'submit_signed_proposal');
    formData.append('id', selectJobId); // Include certificate ID
    formData.append('file', file);
    try {
      const response = await axios.post(`${apiUrl}/signed_proposal.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
        setFilteredJobs(jobs => jobs.map(job => {
        if (job.id === response.data?.job.id) {
          return { ...job, file: response.data.file };
        }
            return job;
        }));
      if (response.data.success) {
        toast.info('Saved!', { position: 'top-center' });
      } else {
        toast.error(response.data.error, { position: 'top-center' });
      }
    } catch (error) {
      toast.error("Oops minor issue with the data.", { position: "top-center" });
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", { position: "top-center" });
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", { position: "top-center" });
      }
    }
  };
  
  const handleNoteChangeParent = (id, newNote) => {
    
    setFilteredJobs(prev => prev.map(job => {
      if (parseInt(job.id) === id) {
        return {
          ...job,
          wip_notes: Array.isArray(job.wip_notes) ? [...job.wip_notes, newNote] : [newNote]
        };
      } else {
        return job;
      }
    }));
  };

  const taxBadge = () => {
    return { color: "purple", num: "800" };
  }

  const getBadgeProps = (type) => {
    switch (type) {
        case 'New System - FA':
            return { color: "pink", num: "900" };//
        case 'Upgrade':
            return { color: "yellow", num: "900" };//
        case 'Floor Work':
            return { color: "indigo", num: "900" };//
        case 'Repair':
            return { color: "green", num: "900" };//
        case 'Filing':
            return { color: "purple", num: "900" };
        default:
            return { color: "gray", num: "900" }; //// Default case
    }
  };

  const toggleShowVoid = () => {
        setShowVoid(!showVoid);
  };

  const handleTyping = (newSearchTerm, filterType) => {
    setLoading(true);

    // Optional: small delay to show the spinner
    setTimeout(() => {
      // If user cleared the input
      if (!newSearchTerm) {
        setFilteredJobs(jobs);
        setLoading(false);
        return;
      }

      // Simple local filter
      const lowerValue = newSearchTerm.toLowerCase();
      let filtered = jobs.filter(job =>
        (job.customer_name && job.customer_name.toLowerCase().includes(lowerValue)) ||
        (job.job_number && job.job_number.toLowerCase().includes(lowerValue)) ||
        (job.job_site && job.job_site.toLowerCase().includes(lowerValue))
      );
      setBaseRows(filtered);      
      setFilteredJobs(applyLastNoteFilterSort(filtered));
      setLoading(false);
    }, 300); // 300ms debounce (adjust as needed)
  };  

  const handleSearchClick = async (searchTerm, filterType, showVoidOverride) => {
    // Optional: check if searchTerm is empty (in case you want extra validation)
    
    const voidFlag = typeof showVoidOverride === 'boolean' ? showVoidOverride : showVoid;

    if (!searchTerm) {
      toast.info('Search bar is empty', { position: 'top-center' });
      return;
    }
    setLoading(true);

    try {
      // 1. Build request body with search and filterType
      const bodyData = {
        status: 'search',
        data: {
          search: searchTerm,
          filter: filterType, // include the selected dropdown filter
        },
      };
      
      // 2. Make the API call
      const response = await axios.post(`${apiUrl}/wip_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });

      // 3. Process response
      if (response.data[0] && Array.isArray(response.data[0])) {
        let filteredData = response.data[0].filter((job) =>
          voidFlag ? job.void === 1 : job.void === 0
        );        
        setCount(response.data[2]);

        // 4. Update your local state
        setBaseRows(filteredData);  
        setFilteredJobs(applyLastNoteFilterSort(filteredData));

        // 5. Save the search state in sessionStorage (optional)
        sessionStorage.setItem('wipSearchTerm', searchTerm);
        // sessionStorage.setItem('wipFilteredJobs', JSON.stringify(filteredData));
        // sessionStorage.setItem('wipShowVoid', showVoid);
        sessionStorage.setItem('wipShowVoid', JSON.stringify(voidFlag));
        sessionStorage.setItem('wipFilterType', filterType);
      } else {
        setFilteredJobs([]);
        toast.error('No results found for ' + searchTerm, { position: 'top-center' });
      }
    } catch (error) {
      console.error('Error searching active projects', error);
      toast.error('An error occurred during the search.', { position: 'top-center' });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    // Clear sessionStorage and reset the state
    sessionStorage.removeItem('wipSearchTerm');
    // sessionStorage.removeItem('wipFilteredJobs');
    sessionStorage.removeItem('wipShowVoid');
    
    setSearchTerm('');
    setFilteredJobs([]);
    setShowVoid(false);
     window.location.reload();
  }; 

  const handleChange = (event, id, user) => {
      bodyDataNotes.wip_id = id;
      const { name, value } = event.target;
      setFilteredJobs(prev => prev.map(job => {
          if (parseInt(job.id) === id) {
              // Create an additional variable or perform additional logic here
              const updatedJob = { ...job, [name]: value };
              bodyDataNotes.data = updatedJob;
              // // You can also update the updatedJob object if needed
              updatedJob.employee_name = user.first_name+" "+user.last_name;
              return updatedJob;
          } else {
              return job;
          }
      }));
  };

  const fetchJobs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/wip_crud.php?getWipList=${key}`, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      });
      if (response.data.error === 'Authentication required') {
        navigate('/Login');
      } else {
        const jobList = Array.isArray(response.data[0]) ? response.data[0] : [];
        if (jobList.length === 0) {
          toast.error("No projects found!", { position: "top-center" });
        }
        setJobs(jobList);
        setBaseRows(jobList); // add new to set //
        setFilteredJobs(applyLastNoteFilterSort(jobList));
        setActiveProjects(response.data[1].total_active_projects);
        setWipRemaining(response.data[1].total_left);
        setWipComplete(response.data[1].total_invoiced);
        setCount(response.data[2]);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", { position: "top-center" });
      }
    } finally {
      setLoading(false);
    }
  };

  // New useEffect to load state from sessionStorage on mount
  useEffect(() => {
    const savedSearchTerm = sessionStorage.getItem('wipSearchTerm') || '';
    const savedShowVoid = JSON.parse(sessionStorage.getItem('wipShowVoid') || 'false');
    const savedFilterType = sessionStorage.getItem('wipFilterType') || 'All';

    setShowVoid(savedShowVoid);
    setSearchTerm(savedSearchTerm);

    // If we had an active search before, re-run it to get fresh data (so edits show)
    if (savedSearchTerm) {
      handleSearchClick(savedSearchTerm, savedFilterType, savedShowVoid); // 👈 see change below
    } else {
      fetchJobs();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);


  useEffect(() => {
    setFilteredJobs(applyLastNoteFilterSort(baseRows));
    setLoading(false);
    setCurrentPage(1);
  }, [lastNoteFilter, sortByLastNoteDesc, idSortDirection, baseRows]);



  const editJob = (id) =>{
      // e.preventDefault()
      navigate(`/wip/edit/${id.idItem}`)
  }

  const confirmVoid = async() => {
    setLoading(true);
    
    const newVoidStatus = voidJobCurrentStatus === 1 ? 0 : 1;
    const bodyData = {
      status: 'void',
      data: { voidID: voidJobID, void:newVoidStatus, jobNumber: filteredJobs.find(job => job.id === voidJobID)?.job_number || '' }
    };
    try {
      const response = await axios.post(`${apiUrl}/wip_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data[0] === 'Success') {
          setFilteredJobs(jobs => jobs.map(job => {
        if (job.id === voidJobID) {
          return { ...job, void: newVoidStatus };
        }
          return job;
        }));
        setShowConfirmModal(false);
        setVoidJobID(null); 
        setVoidJobCurrentStatus(null);

        toast.success('Saved!', {
          position: 'top-center'
        })
      } else {
        toast.error('error updating', {
          position: 'top-center'
        });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
   }

  const voidJobSubmit = (voidJobID, voidJobCurrentStatus) => {
    setVoidJobID(voidJobID);
    setVoidJobCurrentStatus(voidJobCurrentStatus);
    setShowConfirmModal(true);
  };

  const cancelVoid = () => {
    setShowConfirmModal(false);
    setVoidJobID(null);
    setVoidJobCurrentStatus(null);
  };


  const completeSubmit = async(id, completeStatus) => {
    setLoading(true);
    
    const newCompleteStatus = completeStatus === 1 ? 0 : 1;
    const bodyData = {
      status: 'complete',
      data: { completeID: id, complete:newCompleteStatus }
    };

    try {
      const response = await axios.post(`${apiUrl}/wip_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data === 'Success') {
          setFilteredJobs(jobs => jobs.map(job => {
        if (job.id === id) {
          return { ...job, complete: newCompleteStatus };
        }
            return job;
        }));

        toast.success('Saved!', {
          position: 'top-center'
        })
      } else {
        toast.error('error updating', {
          position: 'top-center'
        });
      }
    } catch (error) {
        toast.error("Oops minor issue with the data.", {
        position: "top-center"
        });
        
        if (error.response && error.response.status === 401) {
        toast.error("Session expired. Please login again.", {
        position: "top-center"
        });
        navigate('/login');
        } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area. Speak to the CFO.", {
        position: "top-center"
        });
      }
    } finally {
      setLoading(false);
    }
   }

  const saveJobSite = async () => {
    const { id, job_site, job_number } = jobSiteForm;
    if (!id || !job_site.trim()) {
      toast.error('Job site cannot be empty.', { position: 'top-center' });
      return;
    }

    try {
      // POST to your backend
      const body = { status: 'update_job_site', data: { id, job_site: job_site.trim(), job_number: job_number } };
      const res = await axios.post(`${apiUrl}/wip_crud.php`, body, {
        headers: { 'Content-Type': 'application/json' },
      });
      // Expecting something like: ['success'] or { success: true }
      const ok = (Array.isArray(res.data) && res.data[0] === 'success') || res.data?.success === true;
      if (!ok) {
        toast.error(res.data?.error || 'Failed to update job site.', { position: 'top-center' });
        return;
      }

      // Update UI immediately
      setFilteredJobs(prev =>
        prev.map(j => (j.id === id ? { ...j, job_site: job_site.trim() } : j))
      );
      setJobs(prev =>
        prev.map(j => (j.id === id ? { ...j, job_site: job_site.trim() } : j))
      );

      toast.success('Job site updated!', { position: 'top-center' });
      closeEditJobSite();
    } catch (err) {
      if (err.response?.status === 401) navigate('/login');
      else toast.error('Server error updating job site.', { position: 'top-center' });
    }
  };

  const openEditJobSite = (job) => {
    setJobSiteForm({ id: job.id, job_site: job.job_site, job_number: job.job_number || '' });
    setIsJobSiteModalOpen(true);
  };

  const closeEditJobSite = () => {
    setIsJobSiteModalOpen(false);
    setJobSiteForm({ id: null, job_site: '', job_number: '' });
  };

  const handleNewInputChange = (e) => {
    const { name, value } = e.target;
    setNewObjct((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreditHold = async () => {
    // Implement the form submission logic here
    const bodyData = {
      status: 'submit_credit_hold',
      data: newObjct,
      jobNumber: jobNumber
    };
    try {
      const response = await axios.post(`${apiUrl}/wip_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data[0] === 'success') {
        toast.success('Credit Hold Added!', {
          position: 'top-center'
        });
        setFilteredJobs(jobs => jobs.map(job => {
        if (job.job_number === response.data.credit_hold.job_number) {
          return { ...job, credit_hold: response.data?.credit_hold };
        }
            return job;
        }));
        setJobNumber(null)
        setNewObjct({
                      id: '',
                      amount: 0,
                      notes: ''
                    })
          setIsModalOpen(false);
        // Handle additional logic here if needed
      } else {
        toast.error('Error adding credit hold.', {
          position: 'top-center'
        });
      }
    } catch (error) {
      toast.error('Error adding credit hold.', {
        position: 'top-center'
      });
    }
  };

  const handleCreditHoldDelete = async(id, jobID) => {
    const bodyData = {
      id: id,
      status: 'delete_credit_hold'
    };
      try {
        const response = await axios.post(`${apiUrl}/wip_crud.php`, bodyData, {
          headers: { 'Content-Type': 'application/json' }
        });
        
        if (response.data[0] === 'success') {
          toast.success("Hold Removed!", {
            position: "top-center"
          });
        
          setFilteredJobs(jobs => jobs.map(job => {
          if (job.id === jobID) {
            return { ...job, credit_hold: false};
          }
              return job;
          }));

        } else {
          toast.error(response.data.error || "Failed deleting.", {
            position: "top-center"
          });
        }
      } catch (error) {
          toast.error("Oops minor issue with the data.", {
          position: "top-center"
          });
          
          if (error.response && error.response.status === 401) {
          toast.error("Session expired. Please login again.", {
          position: "top-center"
          });
          navigate('/login');
          } else if (error.response && error.response.status === 403) {
            // setAccess(true);
          toast.error("Oops!! no access to edit.", {
          position: "top-center"
          });
          }
      }
  }

  const getLinksForJob = (job) => {
    let links = [
      { name: 'Edit Job', click: editJob },
      { name: 'Update Job Site', click: () => openEditJobSite(job) }, // 👈 changed
      { name: job.void === 1 ? 'Remove void' : 'Void Job', click: (e, tvoid, index) => voidJobSubmit(job.id, job.void, index) },
      { name: job.complete === 1 ? 'Remove complete' : 'Complete Job', click: (e, jcomplete, index) => completeSubmit(job.id, job.complete, index) },
      { name: job.credit_hold.job_number === job.job_number ? 'Remove Hold' : 'Add Credit Hold',
              click: () => {
                             if(job.credit_hold.job_number === job.job_number)
                             {
                              handleCreditHoldDelete(job.credit_hold.id, job.id)
                             }
                             else
                             {
                              setJobNumber(job.job_number);
                              setIsModalOpen(true); 
                            }
                           }
      },
      { name: 'Add Vendor',  click: () => openVendorModal(job) },
      { name: job.file ? 'Update Signed Proposal' : 'Upload Signed Proposal', click: () => {setIsModalFileOpen(true); setSelectJobId(job.id)} },
      // { name: 'Upload Delivery Receipt', click: '' }
    ];

    return links;
  };

  const handleExportCSV = () => {
    if (!filteredJobs || filteredJobs.length === 0) {
      toast.info('No data to export', { position: 'top-center' });
      return;
    }

    // 1) Define columns (keys in your job objects).
    const columns = [
      'id',
      'job_number',
      'type',
      'job_site',
      'customer_name',
      'job_description',
      'price',
      'f_p_type',
      'complete',
      'pm',
      'void',
      'credit_hold',
      'prev_wage',
      'date'
    ];

    // 2) Create header row
    let csvContent = columns.join(',') + '\n';

    // 3) Loop over filteredJobs to build each row
    filteredJobs.forEach((job) => {
      // Each column in the same order as `columns`
      const row = columns.map((col) => {
        // Convert undefined/null to empty string
        const val = job[col] == null ? '' : job[col];
        // If the data might contain commas or quotes, wrap in quotes & escape quotes
        return `"${String(val).replace(/"/g, '""')}"`;
      });
      csvContent += row.join(',') + '\n';
    });

    // 4) Create a Blob from the CSV
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // 5) Create a temporary link to download the Blob
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'wip_list_export.csv');
    document.body.appendChild(link);
    link.click();

    // 6) Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleExpand = () => {
    setExpand(!expand);
  };

  function NotesList({ notes }) {
  if (!notes?.length) return <div className="text-gray-400">No notes</div>;
  return (
    <ul className="space-y-3">
      {notes.map(n => (
        <li key={n.id}>
          <div className="text-sm whitespace-pre-wrap">{n.notes}</div>
          <div className="text-xs text-gray-500">
            — {n.employee_name} · {n.date}
          </div>
        </li>
      ))}
    </ul>
  );
}

  // Returns { lastNoteAt: Date|null, count: number }
  const getLastNoteMeta = (wip_notes) => {
    if (!wip_notes) return { lastNoteAt: null, count: 0 };
    const arr = Array.isArray(wip_notes)
      ? wip_notes
      : (() => { try { const p = JSON.parse(wip_notes); return Array.isArray(p) ? p : []; } catch { return []; } })();

    if (!arr.length) return { lastNoteAt: null, count: 0 };
    // notes have shape: { id, wip_id, notes, user_id, employee_name, date }
    const last = arr.reduce((max, n) => {
      const d = n?.date ? new Date(n.date) : null;
      return (!d || isNaN(+d)) ? max : (!max || d > max ? d : max);
    }, null);
    return { lastNoteAt: last, count: arr.length };
  };

  // Utility to apply last-note filter/sort to a given array
  const applyLastNoteFilterSort = (rows) => {
    const now = new Date();
    const daysAgo = (n) => new Date(now.getFullYear(), now.getMonth(), now.getDate() - n); // midnight cutoff

    let out = rows.filter(job => {
      const { lastNoteAt, count } = getLastNoteMeta(job.wip_notes);

      switch (lastNoteFilter) {
        case '7d':
          return lastNoteAt && lastNoteAt >= daysAgo(7);
        case '30d':
          return lastNoteAt && lastNoteAt >= daysAgo(30);
        case 'has':
          return count > 0;
        case 'none':
          return count === 0;
        default:
          return true; // 'any'
      }
    });

    // existing note-based sort
    if (sortByLastNoteDesc) {
      out = [...out].sort((a, b) => {
        const A = getLastNoteMeta(a.wip_notes).lastNoteAt;
        const B = getLastNoteMeta(b.wip_notes).lastNoteAt;
        if (!A && !B) return 0;
        if (!A) return 1;
        if (!B) return -1;
        return B - A; // newest first
      });
    }

    // NEW: sort by ID if requested (overrides note sort order)
    if (idSortDirection) {
      out = [...out].sort((a, b) => {
        const aId = Number(a.id) || 0;
        const bId = Number(b.id) || 0;
        if (idSortDirection === 'asc') return aId - bId;
        return bId - aId;
      });
    }

    return out;
  };

  const handleIdSortClick = () => {
    setIdSortDirection(prev => {
      if (prev === null) return 'asc';   // first click → ascending
      if (prev === 'asc') return 'desc'; // second click → descending
      return null;                       // third click → back to unsorted (original order)
    });
  };


  return (
    <>
      {/* <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8"> */}
      <div className={`${expand ? 'w-[80vw] mx-auto mt-8' : 'max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 mt-8'}`}>
        <div className="sm:flex sm:items-center sm:justify-between">

        <div className="sm:flex-auto mt-8 mb-20">
          <HeadingCp label={'WIP (work in progress)'} />
        </div>
         <LegendCP color="fill-yellow-300" label="in-progress" /> 
         <LegendCP color="fill-green-400" label="Complete" /> 
         <LegendCP color="fill-red-600" label="Company On Hold" /> 
         <LegendCP color="fill-red-300" label="Credit Hold" /> 
        </div>
        {userData?.users?.department?.trim().toLowerCase() === 'admin' && activeProjects !== null && (
        <span className="float-end space-y-1">
            {activeProjects > 0 && (
              <div className="text-sm text-gray-800">
                {activeProjects > 1 && (
                  <>
                    Total Active Projects: <CurrencyFormat value={activeProjects}/>
                  </>
                )}
              </div>
            )}
            {wipRemaining > 0 && (
              <div className="text-sm text-green-800">
                {wipRemaining > 1 && (
                  <>
                    Total Remaining WIP: <CurrencyFormat value={wipRemaining}/>
                  </>
                )}
              </div>
            )}
            {wipComplete > 0 && (
              <div className="text-sm text-red-800">
                {wipComplete > 1 && (
                  <>
                    Total Completed WIP : <CurrencyFormat value={wipComplete}/> 
                  </>
                )}
              </div>
            )}            
        </span>  
        )}
        <br/>
        <br/>
        <div className="-mx-4 mt-8">
          <div className="mt-5 ml-4 sm:ml-0 sm:mt-0 flex flex-wrap gap-2 items-center sm:justify-stretch">
            {/* Export CSV */}
            <div className="hidden sm:inline">
            <button
              onClick={handleExpand}
              title="expand"
              className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple-400 hover:bg-purple-700"
            >
              <ArrowsPointingOutIcon className="h-5 w-5" />
            </button>
            </div>
                        
            {/* Proposal List */}
            <NavLink to="/proposal_list">
              <button
                type="button"
                title="Proposal List"
                className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-400 hover:bg-blue-700"
              >
                <DocumentDuplicateIcon className="h-5 w-5 sm:mr-2" />
                <span className="hidden sm:inline">Proposal List</span>
              </button>
            </NavLink>

            {/* Show Void Toggle */}
            <button
              onClick={toggleShowVoid}
              title={showVoid ? 'Show Non-Void' : 'Show Void'}
              className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-400 hover:bg-red-700"
            >
              {showVoid ? (
                <EyeIcon className="h-5 w-5 sm:mr-2" />
              ) : (
                <EyeSlashIcon className="h-5 w-5 sm:mr-2" />
              )}
              <span className="hidden sm:inline">
                {showVoid ? 'Show Non-Void' : 'Show Void'}
              </span>
            </button>

            {/* Credit Hold */}
            <NavLink to="/credit_hold">
              <button
                title="Credit Hold List"
                className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-400 hover:bg-red-700"
              >
                <BanknotesIcon className="h-5 w-5 sm:mr-2" />
                <span className="hidden sm:inline">Credit Hold List</span>
              </button>
            </NavLink>

            {/* Export CSV */}
            <button
              onClick={handleExportCSV}
              title="Export CSV"
              className="inline-flex items-center px-3 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-orange-400 hover:bg-orange-700"
            >
              <ArrowDownTrayIcon className="h-5 w-5 sm:mr-2" />
              <span className="hidden sm:inline">Export CSV</span>
            </button>
            <div className="flex items-center gap-2">
              {/* Filter by last note */}
              <select
                value={lastNoteFilter}
                onChange={(e) => setLastNoteFilter(e.target.value)}
                className="border rounded px-2 py-2 text-sm"
                title="Filter by last note update"
              >
                <option value="any">Notes: Any</option>
                <option value="7d">Notes: Last 7 days</option>
                <option value="30d">Notes: Last 30 days</option>
                <option value="has">Notes: Has notes</option>
                <option value="none">Notes: No notes</option>
              </select>

              {/* Sort toggle */}
              <button
                type="button"
                onClick={() => setSortByLastNoteDesc(s => !s)}
                className="px-2 py-2 border rounded text-sm"
                title="Sort by last note (toggle)"
              >
                {sortByLastNoteDesc ? 'Last note ↓' : 'Last note ↑'}
              </button>
            </div>            
          </div>

          <div className="flex justify-end">
              {/* Move count first (on the left) */}
              <span className="flex justify-end py-2">
                {count > 0 &&  <span className="text-sm text-gray-800"> {count} records </span>}
              </span>
          </div>            
          <div className="relative rounded-md shadow-sm flex-grow mb-3">
              <SearchBarWithDropdown
                filterOptions={['All', 'Active', 'Job Site', 'PM']}
                defaultFilter="All"
                // placeholder="Type something..."
                onSearch={handleSearchClick}
                onReset={handleReset}
                onTyping={handleTyping}
              />
          </div>
          
          <div className="hidden sm:block ">
            <TabsJob />
          </div>

          {loading ? (
                  <div className="flex justify-center py-4">
                  <LoadingSpinner>Loading...</LoadingSpinner>
                    {/* or just <p>Loading...</p> */}
                </div>
          ) : (
            <>
            <table className="min-w-full divide-y divide-x divide-gray-300 border rounded-lg">
                <thead>
                  <tr className='divide-x divide-gray-400 bg-gray-200'> 
                  <th
                    scope="col"
                    className="hidden sm:table-cell py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-blue-900 cursor-pointer"
                  >
                    <button
                      type="button"
                      onClick={handleIdSortClick}
                      className="flex items-center gap-1 underline text-blue-800"
                      title="Sort by ID"
                    >
                      ID/Edit
                      {idSortDirection === 'asc' && <span>↑</span>}
                      {idSortDirection === 'desc' && <span>↓</span>}
                    </button>
                  </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      Proposal # {/* job_number */}
                    </th>
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell whitespace-nowrap">
                      Job Site | Customer {/* job_site */}{/* customer_id */}
                    </th>
                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                      Job Description {/* job_description */}
                    </th>
                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                      F/P {/* f_p_type */}
                    </th>
                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                      Price | Tax {/* price */} {/* Tax */} {/* prev_wage */}
                    </th>
                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                      I% {/* invoiced */}
                    </th>
                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                      P% {/* paid */}
                    </th>
                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                      Date {/* f_u_date */}
                    </th>
                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                      PM {/* pm */}
                    </th>
                    <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">
                      Notes
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">         
                  {currentProjects?.filter(job => showVoid ? job.void === 1 : job.void === 0)
                    .map((job, index) => (
                      <tr
                        key={job.id}
                        className={classNames(
                          {
                            'line-through text-red-600': job.void === 1,
                            'bg-red-200': job.credit_hold,
                            'bg-green-200': job.complete === 1 && !job.credit_hold,
                          },
                          {
                            'bg-white': !job.credit_hold && !job.complete && index % 2 === 0,
                            'bg-gray-100': !job.credit_hold && !job.complete && index % 2 !== 0,
                          },
                          'divide-x'
                        )}
                      >
                        {/* ID/Edit Cell */}
                        <td className="hidden sm:table-cell w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-2">
                          <SubMenu label={job.id} idItem={job.id} links={getLinksForJob(job)} />
                          <dl className="font-normal lg:hidden">
                            <dd className="mt-1 truncate text-gray-700">{job.company}</dd>
                            <dd className="mt-1 truncate text-gray-500 sm:hidden">{job.contractor}</dd>
                            <dd className="mt-1 truncate text-gray-500 sm:hidden">{job.jobnum}</dd>
                          </dl>
                        </td>

                        {/* Proposal # / Job Number Cell */}
                        <td className="px-3 py-2 text-sm text-gray-500 sm:table-cell">
                          <p className='text-[12px]'>
                            {job.credit_hold && job.credit_hold.amount > 0 && (
                              <span className='text-red-800'>Owed: <CurrencyFormat value={job.credit_hold.amount} /></span>
                            )}
                            <br/>
                            <NavLink
                              to={`/wip_detail/${job.id}`}
                              state={{ fromWipList: buildViewState() }}
                            >
                              <button className="text-blue-500">{job.job_number}</button>
                            </NavLink>
                          </p>
                          <p className="text-[10px] text-gray-500">
                            <Badge feed={job.type} {...getBadgeProps(job.type)} />
                          </p>
                        </td>

                        {/* Job Site | Customer Cell */}
                        <td className=" px-3 py-4 text-sm text-gray-500 sm:table-cell">
                          <p className={`text-sm font-medium text-gray-900 font-bold`}>
                            {job.job_site}
                          </p>
                          <span className="flex items-center">
                            <p className={`text-sm ${job.customer_hold ? 'text-red-700' : 'text-gray-500'}`}>
                              {job.customer_name} 
                            </p>
                            <span className='text-orange-500'>
                              {job.customer_hold > 1 ? (<ExclamationTriangleIcon className="h-5 ml-2" />) : ('')}
                            </span>
                          </span>
                          <p className='text-green-500'>
                            {job.contract_engineer || ''}
                          </p>
                        </td>

                        {/* Job Description Cell */}
                        <td className="hidden px-3 py-8 text-sm text-gray-500 sm:table-cell relative whitespace-pre-wrap">
                          {job.job_description}

                          {job.eng_status && (
                            <span className={`absolute top-2 right-10 inline-flex items-center rounded-full 
                                          px-1 py-0.5 text-xs font-medium text-gray-500 ring-1 ring-gray-300 
                                          ${job.eng_status === 'complete' ? 'bg-green-50' : 'bg-yellow-50'}`}>
                              Eng
                            </span>
                          )}

                          {job.acc_status && (
                            <span className={`absolute top-2 right-2 inline-flex items-center rounded-full 
                                          px-1 py-0.5 text-xs font-medium text-gray-500 ring-1 ring-gray-300 
                                          ${job.acc_status === 'complete' ? 'bg-green-50' : 'bg-yellow-50'}`}>
                              Ven
                            </span>
                          )}
                        </td>

                        {/* F/P Type Cell */}
                        <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                          <span className={`inline-flex items-center rounded-full px-2 py-1 text-xs font-medium ring-1 ring-inset ${
                            job.f_p_type === 'F' ? 'bg-green-50 text-green-700 ring-green-600/20' :
                            'bg-yellow-50 text-yellow-800 ring-yellow-600/20'
                          }`}>
                            {job.f_p_type}
                          </span>
                        </td>

                        {/* Price | Tax Cell */}
                        <td className={classNames(
                          job.prev_wage ? preWageClass : 'hidden px-3 py-4 text-sm text-gray-500 sm:table-cell'
                        )}>
                          <CurrencyFormat value={job.price}/>
                        {job.invoiced < 100 && (
                          <div className='text-red-700 text-xs'>&#8723;<CurrencyFormat value={job.price - (job.invoiced * job.price /100)}/></div>
                        )}
                          <p><Badge feed={job.tax_status} {...taxBadge()} /></p>
                        </td>

                        {/* Invoiced Rate Cell */}
                        <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                          {job.invoiced === 100 ? <span className='text-green-700'>{job.invoiced}%</span> : <>{job.invoiced}%</>}
                        </td>

                        {/* Paid Rate Cell */}
                        <td className="hidden px-3 py-4 text-sm text-gray-500 sm:table-cell">
                          {job.paid}%
                        </td>

                        {/* Date Cell */}
                        <td className="hidden py-4 pl-1 text-sm text-gray-500 sm:table-cell">
                          <DateFormat date={job.date} />
                        </td>

                        {/* PM Cell */}
                        <td className="hidden py-4 pl-1 text-sm text-gray-500 sm:table-cell">
                          {job.pm}
                        </td>

                        {/* Notes Cell */}
                        {/* <td className="hidden py-4 pl-1 text-sm text-gray-500 sm:table-cell">
                          <span>
                            {Array.isArray(job.wip_notes) && job.wip_notes.length > 0 && (
                              <ul className="space-y-1">
                                {job.wip_notes.map((n) => (
                                  <li key={n.id}>
                                    <div className="text-sm text-gray-800 whitespace-pre-wrap">{n.notes}</div>
                                    <div className="text-xs text-gray-500">
                                      — {n.employee_name} · <DateFormat date={n.date} />
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </span>                        
                          <button className="text-indigo-600 hover:text-indigo-900" onClick={() => setOpenNotesJobId(job.id)}>
                            <PencilSquareIcon className='h-5 w-5 text-gray-400' aria-hidden="true" />
                          </button>
                          {openNotesJobId === job.id && (
                            <ModalWindow
                              job={
                                <WipComments
                                  onChange={(e) => handleChange(e, job.id)}
                                  api={api}
                                  inside={'notes'}
                                  notes={job.wip_notes}
                                  bodyData={bodyDataNotes}
                                  val={''}
                                  id={job.id}
                                  handleNoteChangeParent={handleNoteChangeParent}
                                  redirectPath={'/wip_list/aj'}
                                  closeNotes={() => setOpenNotesJobId(null)}
                                />
                              }
                              closeNotes={() => setOpenNotesJobId(null)}
                              activeButton={true}
                            />
                          )}
                        </td> */}

                        {/* <td className="hidden py-4 pl-1 text-sm text-gray-500 sm:table-cell">
                          {(() => {
                            const notesArr = normalizeNotes(job.wip_notes);
                            if (!notesArr.length) {
                              return <span className="text-gray-400">No notes</span>;
                            }

                            // Use the first note for preview
                            const firstNote = notesArr[0];
                            const preview = firstNote?.notes || '';

                            return (
                              <div>
                                {/* 1️⃣ truncated text */}
                                {/* 2️⃣ user and date always visible outside */}
                                {/* <div className="text-xs text-blue-500 mt-1">
                                  — {firstNote.employee_name} <p><DateFormat date={firstNote.date} /></p>
                                </div>

                                <Truncate
                                  text={preview}
                                  handleNotesView={() => handleNotesView(job.id)}
                                />

                                {/* 3️⃣ modal window for all notes */}
                                {/* {notesIdOpen === job.id && (
                                  <ModalWindow
                                    job={<NotesList notes={notesArr} />}
                                    closeNotes={closeNotes}
                                    activeButton={true}
                                  />
                                )}
                              </div>
                            );
                          })()}
                        </td> */} 

                        {/* Notes Cell */}
                        <td className="hidden py-4 pl-1 text-sm text-gray-500 sm:table-cell max-w-[700px]">
                          <ResponsiveNotes
                            notes={job.wip_notes}
                            DateFormat={DateFormat}
                            rowId={job.id}
                            onOpenModal={handleNotesView}
                          />

                          {notesIdOpen === job.id && (
                              <ModalWindow
                                job={<NotesList notes={job.wip_notes} />}
                                closeNotes={closeNotes}
                                activeButton={true}
                              />
                            )}
                            <button
                              className="text-indigo-600 hover:text-indigo-900"
                              onClick={() => setOpenNotesJobId(job.id)}
                            >
                              <span className="text-xs text-blue-800 p-1">
                                {Array.isArray(job.wip_notes) && job.wip_notes.length > 0
                                  ? 'View All'
                                  : 'Add Notes'}
                              </span>
                            </button>
                          {openNotesJobId === job.id && (
                            <ModalWindow
                              job={
                                <WipComments
                                  onChange={(e) => handleChange(e, job.id)}
                                  api={api}
                                  inside={'notes'}
                                  notes={job.wip_notes}
                                  bodyData={bodyDataNotes}
                                  val={''}
                                  id={job.id}
                                  handleNoteChangeParent={handleNoteChangeParent}
                                  redirectPath={'/wip_list/aj'}
                                  closeNotes={() => setOpenNotesJobId(null)}
                                />
                              }
                              closeNotes={() => setOpenNotesJobId(null)}
                              activeButton={true}
                            />
                          )}                          
                        </td>
                      </tr>
                    ))}
                </tbody>
            </table>
            {/* <-- NEW: pagination controls */}
            <div className="flex justify-center items-center mt-4 space-x-2">
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Prev
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded disabled:opacity-50"
              >
                Next
              </button>

              {/* optional: change page size */}
              <select
                className="ml-4"
                value={pageSize}
                onChange={(e) => {
                  setPageSize(+e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="300">300</option>
              </select>
            </div> 
            </>            
          )}
        </div>
      </div>
  
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <h2 className="text-lg font-semibold text-gray-900">Add New Credit Hold</h2>
        <form>
          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700">Amount</label>
            <input
              type="number"
              name="amount"
              value={newObjct.amount}
              required={true}
              onChange={handleNewInputChange}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700">Notes</label>
            <textarea
              type="text"
              rows={3}
              name="notes"
              value={newObjct.notes}
              onChange={handleNewInputChange}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
            />
          </div>

          <div className="mt-9 float-end">
            <button
              type="button"
              onClick={handleCreditHold}
              className="inline-flex justify-center rounded-md border border-transparent bg-green-600 hover:bg-indigo-700 py-2 px-4 text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              Submit
            </button>
          </div>
        </form>
      </Modal>
    
      <Modal isOpen={isModalFileOpen} onClose={() => setIsModalFileOpen(false)}>
        <h2 className="text-lg font-semibold text-gray-900">Upload Signed File</h2>
        <form onSubmit={handleUploadFile}>
      <div className="form-group">
        <input
          type="file"
          name="file"
          id="file"
          onChange={handleFileChange}
          required
          className="mt-1 block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
        />
      </div>
        <div className="mt-9 float-right">
          <button
            type='submit'
            className={`inline-flex justify-center rounded-md border border-transparent
                      py-2 px-4 text-sm font-medium text-white shadow-sm bg-green-600
                      focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}>
            Upload
          </button>
        </div>
        </form>
      </Modal>

      <Modal isOpen={isJobSiteModalOpen} onClose={closeEditJobSite}>
        <h2 className="text-lg font-semibold text-gray-900">Edit Job Site</h2>
        <div className="mt-4 space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700">Job Site</label>
            <input
              type="text"
              value={jobSiteForm.job_site}
              onChange={(e) => setJobSiteForm(s => ({ ...s, job_site: e.target.value }))}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              placeholder="Enter job site"
              autoFocus
            />
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={closeEditJobSite}
            className="px-4 py-2 rounded border"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={saveJobSite}
            className="px-4 py-2 rounded bg-green-600 text-white hover:bg-green-700"
          >
            Save
          </button>
        </div>
      </Modal>

      <Modal isOpen={isVendorModalOpen} onClose={closeVendorModal}>
        <h2 className="text-lg font-semibold text-gray-900">
          Add Vendor
        </h2>

        {selectedVendorJob && (
          <div className="mt-2 text-sm text-gray-500">
            <p>
              Job: <span className="font-medium">{selectedVendorJob.job_number}</span>
            </p>
            <p>
              Site: <span className="font-medium">{selectedVendorJob.job_site}</span>
            </p>
          </div>
        )}

        <div className="mt-4 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Vendor Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="vendor_name"
              value={vendorForm.vendor_name}
              onChange={handleVendorInputChange}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              placeholder="Enter vendor name"
              autoFocus
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Notes
            </label>
            <textarea
              name="notes"
              rows={3}
              value={vendorForm.notes}
              onChange={handleVendorInputChange}
              className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              placeholder="Optional notes"
            />
          </div>

          <div className="flex justify-end">
            <button
              type="button"
              onClick={handleAddVendor}
              disabled={!vendorForm.vendor_name.trim()}
              className={`px-4 py-2 rounded text-white ${
                !vendorForm.vendor_name.trim()
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-green-600 hover:bg-green-700'
              }`}
            >
              Save Vendor
            </button>
          </div>

          <div className="border-t pt-4">
            <h3 className="text-sm font-semibold text-gray-800 mb-2">
              Added Vendors
            </h3>

            {Array.isArray(selectedVendorJob?.vendors) && selectedVendorJob.vendors.length > 0 ? (
              <ul className="space-y-3">
                {selectedVendorJob.vendors.map((vendor) => (
                  <li
                    key={vendor.id}
                    className="rounded-md border border-gray-200 p-3 bg-gray-50"
                  >
                    <p className="text-sm font-medium text-gray-900">
                      {vendor.vendor_name}
                    </p>

                    {vendor.notes && (
                      <p className="text-sm text-gray-600 whitespace-pre-wrap mt-1">
                        {vendor.notes}
                      </p>
                    )}

                    <p className="text-xs text-gray-400 mt-1">
                      {vendor.date}
                    </p>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-gray-400">
                No vendors added yet.
              </p>
            )}
          </div>
        </div>
      </Modal>      

      {/* Confirmation Modal */}
      {showConfirmModal && voidJobID && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen text-center">
            {/* Background overlay */}
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            {/* Modal panel */}
            <div
              className="inline-block bg-white rounded-lg text-left 
              overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div>
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Confirm Deletion
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      <br/>
                      {voidJobCurrentStatus === 1 ? (
                        <>
                          This action will not delete the record but will mark it as active. Are you sure you want to proceed with removing the void status 
                          from Job ID <strong>{voidJobID}</strong>                         
                        </>
                      ) : (
                        <>
                          This action will not delete the record but will mark it as void. Are you sure you want to proceed with voiding 
                          Job ID <strong>{voidJobID}</strong>                         
                        </>                        
                      )}
                    </p>
                  </div>
                </div>
              </div>
              {/* Modal actions */}
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
                <button
                  onClick={confirmVoid}
                  className="w-full inline-flex justify-center rounded-md border border-transparent 
                  shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Void
                </button>
                <button
                  onClick={cancelVoid}
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 
                  shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <br/>
      <br/>
      <br/>
    </>
  )
}
export default WipListPage;
